

(function () {

    function sendMessage(message) {
        return new Promise((resolve, reject) => {
            var XHR = new XMLHttpRequest();
            var FD = new FormData();

            FD.append('message', message);

            XHR.addEventListener('load', function (event) {
                if (XHR.status === 200) {
                    resolve();
                } else {
                    reject(XHR.status + ' ' + XHR.statusText);
                }
            });

            XHR.addEventListener('error', function (event) {
                reject(event);
            });

            XHR.open('POST', 'contact.php');

            try {
                XHR.send(FD);
            } catch (error) {
                reject(error);
            }
        });
    }

    // Activate all close buttons
    const closeElements = document.querySelectorAll('.close-popup');
    for (let i = 0; i < closeElements.length; i++) {
        closeElements[i].addEventListener('click', (event) => {
            event.target.closest('.popup-container').classList.remove('active');
            event.target.blur();
        });
    }

    // Question popup
    const sendQuestionButton = document.getElementById('send-question-button');
    const questionError = document.getElementById('question-popup-error');
    const questionInput = document.getElementById('input-question-text');
    sendQuestionButton.addEventListener('click', (event) => {
        const text = questionInput.value;
        if (!text) {
            questionError.innerText = 'Please enter a question!';
            return;
        } else {
            questionError.innerText = '';
        }
        sendQuestionButton.innerText = 'SENDING...';
        sendQuestionButton.disabled = true;
        questionInput.disabled = true;
        sendMessage(text).then(() => {
            event.target.closest('.popup-container').classList.remove('active');
            event.target.blur();
            sendQuestionButton.innerText = 'SEND';
            sendQuestionButton.disabled = false;
            questionInput.disabled = false;
            questionInput.value = '';
        }, (error) => {
            sendQuestionButton.innerText = 'SEND';
            sendQuestionButton.disabled = false;
            questionInput.disabled = false;
            questionError.innerText = 'An unexpected error happened: ' + error;
        })
    });

}());

